const ru = {
  app: {
    title: "Покер на костях",
    tagline: "Цифровой блокнот · играй вживую",
  },
  auth: {
    usernamePlaceholder: "Имя пользователя",
    login: "Войти",
    register: "Регистрация",
    createAccount: "Создать аккаунт",
    welcomeBack: "С возвращением!",
    orContinueWithEmail: "Или через email",
    alreadyHaveAccount: "Уже есть аккаунт? Войти",
    dontHaveAccount: "Нет аккаунта? Регистрация",
    playAsGuest: "Играть как гость",
    emailPlaceholder: "Email адрес",
    passwordPlaceholder: "Пароль",
    confirmPasswordPlaceholder: "Повторите пароль",
    passwordsDoNotMatch: "Пароли не совпадают",
    googleLogin: "Google",
    appleLogin: "Apple",
    googleComingSoon: "Вход через Google скоро появится!",
    appleComingSoon: "Вход через Apple скоро появится!",
    guestLoginFailed: "Ошибка гостевого входа",
    telegramFailed: "Не удалось войти через Telegram. Проверьте соединение и попробуйте ещё раз.",
    retry: "Повторить",
    forgotPassword: "Забыли пароль?",
    resetInstructions: "Введите email — мы пришлём ссылку для сброса пароля.",
    enterEmailForReset: "Введите email для сброса пароля",
    sendResetEmail: "Отправить ссылку",
    resetEmailSent: "Письмо отправлено! Проверьте почту.",
    backToLogin: "Назад",
    terms: "Продолжая, вы соглашаетесь с Условиями использования и Политикой конфиденциальности.",
  },
  lobby: {
    newGame: "Новая игра",
    codePlaceholder: "КОД ИГРЫ",
    recentGames: "Недавние игры",
    finished: "завершена",
    won: "Победа",
    noGames: "Нет недавних игр",
    enter: "Войти",
    rules: "Правила",
    rating: "Рейтинг",
    offlineGame: "Игра на одном телефоне (оффлайн)",
    live: "В ЭФИРЕ",
  },
  setup: {
    title: "Настройка игры",
    playerOrder: "Порядок игроков",
    subtitle: "Добавьте всех игроков перед началом",
    gameCode: "Код игры",
    addPlayer: "Добавить игрока",
    startGame: "Начать игру",
    waitingForAdmin: "Ожидание начала игры…",
    waiting: "Ожидание начала…",
    admin: "👑 Администратор",
    telegramUser: "Пользователь Telegram",
    guestPlayer: "Гость",
    visibilityOfScore: "Видимость очков",
    realtime: "В реальном времени",
    realtimeDesc: "Все видят очки сразу",
    finalOnly: "В конце игры",
    finalOnlyDesc: "Очки скрыты до окончания",
    gameMode: "Режим игры",
    freeMode: "Обычный",
    freeModeDesc: "Физические кубики, запись вручную",
    virtualDiceMode: "Виртуальные кубики",
    players: "Игроки",
    qrScan: "Отсканируйте, чтобы вступить",
    shareInvite: "Пригласить друзей",
    inviteMessage: "🎲 Присоединяйся к моей игре в Покер на костях! Код: {{code}}",
    virtualDiceModeDesc: "Броски в приложении, валидация очков",
    joinAsPlayer: "Вступить в игру",
    scanToJoinWeb: "Отсканируйте QR-код, чтобы войти с телефона",
    host: "Хост",
    you: "Вы",
    backToLobby: "В лобби",
  },
  addPlayer: {
    title: "Добавить игрока",
    tabPast: "👥 Прошлые игроки",
    tabCustom: "✏️ Своё имя",
    tabSearch: "🔍 Поиск",
    search: "Поиск…",
    searchPlaceholder: "Имя пользователя или имя",
    noContacts: "Нет прошлых игроков",
    noMatches: "Нет совпадений",
    noResults: "Ничего не найдено",
    nameLabel: "Имя (Папа, Мама, Сестра…)",
    namePlaceholder: "напр. Папа",
    avatarLabel: "Аватар",
    add: "Добавить {{name}}",
  },
  game: {
    editedBy: "{{editor}} изменил(а) «{{category}}» у {{target}}",
    school: "Школа",
    combinations: "Комбинации",
    total: "ИТОГО",
    bonus: "бонус",
    scoresHidden: "очки скрыты",
    finishGame: "Завершить игру",
    showResults: "Подсчитать результаты",
    gameOver: "🏆 Игра окончена",
    confirmFinishTitle: "Завершить игру?",
    confirmFinishDesc: "Таблица будет заблокирована и объявится победитель.",
    cancel: "Отмена",
    finish: "Завершить",
    close: "Закрыть",
    edit: "ИЗМЕНИТЬ",
    round: "Раунд",
    compactView: "Компактный вид",
    waitingForAdminFinish: "Ожидание завершения игры администратором...",
    category: "Категория",
    inviteCode: "Код",
    pendingUpdates: "ожидают отправки",
    diceTray: "Кубики",
    roll: "Бросить",
    rollAgain: "Перебросить",
    waitingForTurn: "Ожидание хода...",
    swipeHint: "Листайте вбок между игроками",
    swipeToThrow: "Свайп вверх — бросить",
    keepSwiping: "Ещё немного...",
    release: "Отпускай!",
    rethrow: "К броску",
    reroll: "К броску",
    keep: "Оставлено",
    selectHint: "Нажми чтобы оставить · свайп вверх бросить",
    reset: "Сброс",
  },
  notifications: {
    school_flunker: "Двоечник!!",
    school_graduated: "Выпускной!",
    school_honors: "С красным дипломом!",
    small_but_mine: "Маленький, но мой!",
    main_game_started: "Игра началась!",
    poker_rolled: "ПОКЕР!!!",
    take_the_lead: "Вырывается вперёд!",
    last_round: "Финальный раунд!",
    crossed_out: "Не повезло…",
    achievementUnlocked: "Достижение разблокировано!",
  },
  categories: {
    ones: "Единицы",
    twos: "Двойки",
    threes: "Тройки",
    fours: "Четвёрки",
    fives: "Пятёрки",
    sixes: "Шестёрки",
    one_pair: "1 Пара",
    two_pairs: "2 Пары",
    three_of_kind: "Сет",
    straight1: "Малый стрит",
    straight2: "Большой стрит",
    full_house: "Фулл-хаус",
    four_of_kind: "Каре",
    poker: "Покер",
    garbage: "Мусор",
  },
  hints: {
    ones: "Сумма единиц · цель: 3",
    twos: "Сумма двоек · цель: 3",
    threes: "Сумма троек · цель: 3",
    fours: "Сумма четвёрок · цель: 3",
    fives: "Сумма пятёрок · цель: 3",
    sixes: "Сумма шестёрок · цель: 3",
    one_pair: "Сумма пары",
    two_pairs: "Сумма двух пар",
    three_of_kind: "Сумма трёх одинаковых",
    straight1: "Фикс: 15 очков",
    straight2: "Фикс: 20 очков",
    full_house: "Сумма всех 5 кубиков + 10",
    four_of_kind: "Сумма четырёх одинаковых + 20",
    poker: "Сумма всех 5 кубиков + 50",
    garbage: "Сумма любых кубиков",
  },
  scoreInput: {
    howMany: "Сколько {{n}} выпало?",
    crossOut: "✕ Зачеркнуть",
    confirm: "Записать",
    suggested: "Подсказка по кубикам",
    tip: "Совет",
    clear: "Очистить",
    scoreFixed: "✓ Записать {{pts}} очков",
    record: "Записать",
    selectCount: "Выберите количество",
    fromHand: "С руки (×2)",
    flatBonus: "бонус (не удваивается с руки)",
  },
  winner: {
    title: "КАТАЛА",
    wins: "Победитель!",
    place1: "🥇 1 место",
    place2: "🥈 2 место",
    place3: "🥉 3 место",
    newGame: "Новая игра",
    backToLobby: "В лобби",
    pts: "очков",
    shareResults: "Поделиться результатами",
    shareResultsMessage: "🎲 Результаты игры в {{title}}:\n{{results}}",
    notifyPlayers: "Уведомить игроков через Бота",
    rematch: "Реванш",
  },
  tournament: {
    newTournament: "Новый турнир",
    standings: "Турнирная таблица",
    gameCount: "Количество игр",
    nextGame: "Следующая игра",
    tournamentOver: "Турнир окончен",
    grandTotal: "Общий итог",
    winsColumn: "Победы",
    winnerMode: "Определение победителя",
    byPoints: "По очкам",
    byWins: "По победам",
    byPointsDesc: "Побеждает игрок с наибольшей суммой очков за все игры",
    byWinsDesc: "Побеждает игрок с наибольшим числом выигранных игр (очки при равенстве)",
    points: "Очки",
    game: "Игра",
    round: "Раунд",
    matrix: "Таблица",
    rounds: "Список игр турнира",
    create: "Создать турнир",
    join: "Вступить в турнир",
    confirmKick: "Удалить {{name}} из турнира?",
    waitingParticipants: "Ожидание участников...",
    adminStart: "Администратор должен запустить следующую игру",
    progress: "Прогресс",
    active: "Турнир идёт",
    finished: "Турнир завершён",
    suddenDeath: "Раунд внезапной смерти!",
    spectatorMode: "Режим зрителя",
    scanToWatchStandings: "Отсканируйте, чтобы следить за таблицей",
    consistencyBonus: "Бонус за стабильность",
    comebackKid: "Мастер камбэка",
    theGrinder: "Трудяга",
    finishTournament: "Завершить турнир",
    champion: "Чемпион турнира!",
    finalStandings: "Итоговая таблица",
    shareResults: "Поделиться результатами турнира",
    backToHome: "На главную",
  },
  stats: {
    title: "Статистика",
    globalRank: "в мире",
    leaderboard: "Таблица лидеров",
    myStats: "Моя статистика",
    recentGames: "Последние игры",
    noGames: "Игры ещё не завершены",
    player: "Игрок",
    avg: "Среднее",
    best: "Рекорд",
    elo: "Рейтинг",
    noPersonal: "Сыграйте хотя бы одну игру, чтобы увидеть вашу статистику!",
    wins: "Победы",
    avgScore: "Ср. очки",
    bestScore: "Лучшая игра",
    gamesPlayed: "Игры",
    winRate: "Процент побед",
    scoreBreakdown: "Распределение очков",
    avgSchool: "Школа (ср.)",
    avgCombos: "Комбо (ср.)",
    worstGame: "Худшая игра",
    totalScore: "Всего набрано очков",
    h2h: "Личные встречи",
    selectOpponent: "Выберите соперника...",
    draws: "Ничьи",
    achievements: "Достижения",
    profile: "Профиль",
    viewProfile: "Посмотреть профиль",
  },
  settings: {
    diceColors: "Стиль кубиков",
    default: "Обычные",
    colorful: "Цветные",
    sound: "Звук",
    style: "Стиль",
    colorfulDice: "Цветные кубики",
    theme: "Тема",
    tableTheme: "Тема стола",
  },
  rules: {
    title: "Правила игры",
    overview: "Обзор",
    overviewDesc: "Покер на костях — это игра для 2 и более человек. Каждый игрок бросает 5 кубиков до 3-х раз за ход, чтобы собрать лучшие комбинации и заполнить свой бланк.",
    turnFlow: "Ход игры",
    step1Title: "Бросок и Удержание",
    step1Desc: "Сделайте первый бросок. Выберите кубики, которые хотите оставить, и перебросьте остальные (до 2-х раз).",
    step2Title: "Запись результата",
    step2Desc: "После любого броска выберите категорию для записи. Один ход — одна заполненная ячейка.",
    bonusTitle: "Бонус «С руки» (×2)",
    bonusDesc: "Собрали комбинацию с самого первого броска? Очки за кубики удваиваются!",
    schoolTitle: "Школа (Верхняя часть)",
    schoolDesc: "Цель — собрать ровно по 3 кубика каждого номинала (от 1 до 6). Очки пишутся как разница от цели:",
    ptsOnSixes: "+6 очков (на 6-ках)",
    ptsPenaltyOnSixes: "-6 очков (на 6-ках)",
    schoolBonuses: "Бонусы школы",
    allRowsPositive: "Все ячейки в плюсе: +100 очков",
    allRowsZeroed: "Все ячейки по нулям (✕): +50 очков",
    negativePenalty: "Итоговый минус: -50 очков (штраф)",
    restrictionHint: "⚠️ Первые 3 раунда можно записывать только в Школу.",
    combosTitle: "Комбинации (Нижняя часть)",
    onePair: "1 пара",
    onePairDesc: "2 одинаковых кубика. Сумма двух",
    twoPairs: "2 пары",
    twoPairsDesc: "2×2 одинаковых. Сумма всех четырёх",
    threeOfKind: "Сет (три одинаковых)",
    threeOfKindDesc: "3 одинаковых кубика. Сумма трёх",
    straight: "Стрит",
    straightDesc: "1-2-3-4-5 (15 очков) или 2-3-4-5-6 (20 очков)",
    fullHouse: "Фулл-хаус",
    fullHouseDesc: "3 + 2 одинаковых. Сумма + 10",
    pokerDesc: "4 или 5 одинаковых. Сумма + 20/+50",
    garbageTitle: "Мусор (Шанс)",
    garbageDesc: "Любая сумма кубиков",
    mustCrossOut: "Если ничего не подходит, вы должны вычеркнуть одну категорию (0 очков).",
    gotIt: "Понятно!",
  },
} as const;

export default ru;

// Structural shape — all leaf values become `string` so en.ts can hold different literals
type DeepString<T> = {
  [K in keyof T]: T[K] extends Record<string, unknown>
    ? DeepString<T[K]>
    : string;
};
export type Translations = DeepString<typeof ru>;
